import moment from 'moment';
import { IWorkItem } from '../../store/typings';

export const getLastWeekData = (actions: IWorkItem[]) => {
  const lastWeekStart = moment().subtract(1, 'week').startOf('week');
  const lastWeekEnd = moment().subtract(1, 'week').endOf('week');

  return actions.filter((item) => {
    const itemDate = moment(item.Fields['System.ChangedDate']);
    return itemDate.isBetween(lastWeekStart, lastWeekEnd, null, '[]'); // '[]' includes both ends
  });
};

export const getLastMonthData = (actions: IWorkItem[]) => {
  const lastMonthStart = moment().subtract(1, 'month').startOf('month');
  const lastMonthEnd = moment().subtract(1, 'month').endOf('month');

  return actions.filter((item) => {
    const itemDate = moment(item.Fields['System.ChangedDate']);
    return itemDate.isBetween(lastMonthStart, lastMonthEnd, null, '[]'); // '[]' includes both ends
  });
};